// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Close button */
.cross_icon {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.cross_icon .close-button {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.cross_icon .close-button:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.cross_icon .close-button:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.cross_icon .close-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.cross_icon .close-button:active {
  transform: scale(0.95);
}
.cross_icon .close-button ion-img {
  width: 20px;
  height: 20px;
}

/* Hero section */
.hero {
  padding: 30px 25px 25px;
  color: var(--ion-color-main);
  text-align: left;
}
.hero h1 {
  font-family: AppFontSemiBold, sans-serif;
  font-size: 22px;
  line-height: 33px;
  text-transform: uppercase;
  margin: 10px 0px 5px;
}
.hero p {
  font-family: AppFontLight, sans-serif;
  color: rgba(47, 51, 58, 0.7);
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 15px;
}

/* Search form */
.search-form {
  width: 100%;
}

/* Search bar */
.search-bar {
  border: 2px solid #e5e5e5;
  border-radius: 7px;
  --inner-padding-end: 5px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  /* Focus styles */
  /* Input field */
  /* Container styling */
  /* Start icon */
  /* Clear button */
  /* Search button container */
}
.search-bar:focus-within {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.search-bar ion-input {
  color: var(--ion-color-main) !important;
  background: #FFFFFF;
  font-size: 16px;
}
.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}
.search-bar .start-icon {
  margin-inline-end: 12px;
}
.search-bar .clear-button {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.search-bar .clear-button:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.search-bar .clear-button:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.search-bar .clear-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.search-bar .clear-button:active {
  transform: scale(0.95);
}
.search-bar .suche .search-button {
  background: var(--ion-color-primary);
  border: none;
  border-radius: 6px;
  color: white;
  fill: white;
  min-height: 39px;
  padding: 8px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Disabled state */
}
.search-bar .suche .search-button span {
  font-family: AppFontBold, sans-serif;
  transition: background-color 0.2s ease;
  color: white;
  text-transform: uppercase;
}
.search-bar .suche .search-button:focus {
  outline: 2px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.search-bar .suche .search-button:focus-visible {
  outline: 2px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
}
.search-bar .suche .search-button:hover:not(:disabled) {
  background-color: var(--ion-color-primary-shade);
}
.search-bar .suche .search-button:active:not(:disabled) {
  background-color: var(--ion-color-primary-tint);
}
.search-bar .suche .search-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Search container */
.search-container ion-col {
  padding: 0 !important;
  border-radius: var(--ion-border-radius);
}

/* No results message */
.no-place {
  padding: 16px 9px;
  font-family: AppFont-bold, sans-serif;
  background: #FFFFFF;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: var(--ion-border-radius);
  font-size: 12px;
  line-height: 131.5%;
  color: var(--ion-color-secondary);
}

/* Suggested place button */
.suggested-place {
  border-radius: 7px;
  border: 2px solid #D5DDDD;
  background: #F7F9F9;
  place-items: center;
  padding: 15px 20px;
  margin-top: 5px;
  text-align: left;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.suggested-place:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
  border-color: var(--ion-color-primary);
}
.suggested-place:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.suggested-place:hover {
  background-color: #E8F0F0;
  border-color: var(--ion-color-primary);
}
.suggested-place:active {
  background-color: #D0E4E4;
}
.suggested-place .navigate-icon {
  margin-right: 15px;
  fill: var(--ion-color-primary) !important;
  flex-shrink: 0;
}
.suggested-place .actual-position-title {
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
  font-family: AppFontSemiBold, sans-serif;
  margin: 0;
}
.suggested-place .actual-position {
  font-size: 13px;
  margin-top: 5px;
  line-height: 16px;
  color: #6D7075;
  font-family: AppFontLight, sans-serif;
  margin-bottom: 0;
}

/* Search results dropdown */
.pac-container {
  background: white;
  width: 100%;
  padding: 8px 0 !important;
  margin-top: 5px;
  border-radius: 16px !important;
  border: 2px solid #e5e5e5 !important;
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
}
.pac-container .pac-item {
  border-top: none !important;
  font-family: AppFontBold, sans-serif;
  padding: 16px 20px;
  line-height: 1 !important;
  font-size: 14px !important;
  color: var(--ion-color-secondary);
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.pac-container .pac-item:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: -2px;
  background-color: rgba(113, 167, 97, 0.1);
}
.pac-container .pac-item:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: -2px;
}
.pac-container .pac-item:hover {
  background-color: rgba(113, 167, 97, 0.05);
}
.pac-container .pac-item:active {
  background-color: rgba(113, 167, 97, 0.15);
}
.pac-container .pac-item:last-child {
  border-bottom: none;
}
.pac-container .pac-item .pac-matched {
  font-family: AppFontBold, sans-serif;
  font-weight: bold;
}
.pac-container .pac-item .pac-icon {
  margin-right: 10px;
}

/* Footer buttons */
#buttonContainer {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.vertical-space-around {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

/* Continue button */
.cnt-btn {
  width: 100%;
  padding: 16px;
  text-align: center;
  font-family: AppFontBold, sans-serif;
  color: white;
  font-weight: bold;
  letter-spacing: 0.075em;
  text-transform: uppercase;
  cursor: pointer;
  margin: 0;
  background: var(--ion-color-primary);
  border-radius: 50px;
  border: none;
  transition: background-color 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.cnt-btn:focus {
  outline: 2px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.cnt-btn:focus-visible {
  outline: 2px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
}
.cnt-btn:hover {
  background-color: var(--ion-color-primary-shade);
}
.cnt-btn:active {
  background-color: var(--ion-color-primary-tint);
}
@media (min-width: 991px) {
  .cnt-btn {
    margin: auto;
  }
}

/* Geolocation button */
.geo-btn {
  background: #62ABA4;
  font-family: AppFont-bold, sans-serif;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  padding: 16px;
  text-align: center;
  letter-spacing: 0.075em;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 50px;
  transition: background-color 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.geo-btn:focus {
  outline: 2px solid #4A8A83;
  outline-offset: 2px;
  box-shadow: 0 0 0 3px rgba(98, 171, 164, 0.25);
}
.geo-btn:focus-visible {
  outline: 2px solid #4A8A83;
  outline-offset: 2px;
}
.geo-btn:hover {
  background-color: #4A8A83;
}
.geo-btn:active {
  background-color: #3F7A73;
}
.geo-btn ion-icon {
  width: 22px;
  height: 25px;
  margin-right: 10px;
}
@media (min-width: 991px) {
  .geo-btn {
    width: 600px;
    margin: auto;
  }
}

/* Typography */
.heading-text {
  font-size: 19px;
  color: var(--ion-text-color);
  font-weight: 500;
  line-height: 145%;
  margin: 20px 0 10px;
}
.heading-text.desktop {
  display: block;
}
@media (max-width: 992px) {
  .heading-text.desktop {
    display: none;
  }
}
.heading-text.mobile {
  display: none;
}
@media (max-width: 992px) {
  .heading-text.mobile {
    display: block;
  }
}

.sub-heading {
  font-size: 18px;
  line-height: 134%;
  margin: 0;
}

/* Footer */
.footer-btn {
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  color: white;
}

ion-footer,
.footer-btn {
  background: unset;
  padding: 0 28px 26px !important;
  box-shadow: none;
}
@media (min-width: 991px) {
  ion-footer,
  .footer-btn {
    margin: 0px 50px 0 !important;
    width: calc(100% - 100px) !important;
  }
}
ion-footer .button,
.footer-btn .button {
  flex: 1;
  background: var(--ion-color-primary) !important;
  color: white !important;
  text-align: center;
}
ion-footer .button:first-child,
.footer-btn .button:first-child {
  margin-right: 3px;
}
ion-footer .button:last-child,
.footer-btn .button:last-child {
  margin-left: 3px;
}
ion-footer .button.active,
.footer-btn .button.active {
  transition: 0.3s linear;
  background: var(--ion-color-main);
  color: var(--ion-text-color);
}
ion-footer .button.active:hover,
.footer-btn .button.active:hover {
  transition: 0.3s linear;
  background: var(--ion-color-main);
}

/* Responsive layouts */
.desktop {
  display: none;
  margin: 50px 25px;
}
@media (min-width: 991px) {
  .desktop {
    display: block;
  }
}
.desktop .hero {
  background: white;
  border: 0.5px solid #E5E5E5;
  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);
  border-radius: 10px;
}

.mobile {
  display: none;
}
@media (max-width: 992px) {
  .mobile {
    display: block;
  }
}

.logo-block {
  width: 100%;
  display: flex;
  justify-content: center;
}
.logo-block ion-img {
  width: 76px;
}
@media (max-width: 992px) {
  .logo-block {
    display: none;
  }
}

@media (min-width: 991px) {
  .desktop-hero {
    text-align: center;
    margin: 50px 25px;
  }
}

/* High contrast mode enhancements */
.bsg-high-contrast .search-bar {
  border-color: black;
}
.bsg-high-contrast .search-bar:focus-within {
  border-color: #0078d7;
  box-shadow: 0 0 0 3px rgba(0, 120, 215, 0.25);
}
.bsg-high-contrast .close-button:focus, .bsg-high-contrast .clear-button:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .search-button {
  background: black !important;
  border: 2px solid white;
}
.bsg-high-contrast .search-button:focus {
  box-shadow: 0 0 0 3px #0078d7;
}
.bsg-high-contrast .suggested-place {
  border-color: black;
  background: white;
}
.bsg-high-contrast .suggested-place:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .suggested-place .actual-position-title, .bsg-high-contrast .suggested-place .actual-position {
  color: black !important;
}
.bsg-high-contrast .pac-container {
  border-color: black !important;
}
.bsg-high-contrast .pac-container .pac-item {
  color: black !important;
}
.bsg-high-contrast .pac-container .pac-item:focus {
  outline: 3px solid #0078d7;
  background-color: #e6f3ff;
}
.bsg-high-contrast .cnt-btn {
  background: black;
  border: 2px solid white;
}
.bsg-high-contrast .cnt-btn:focus {
  box-shadow: 0 0 0 3px #0078d7;
}
.bsg-high-contrast .no-place {
  border: 2px solid black;
  color: black !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/check-delivery-radius-modal/check-delivery-radius-modal.component.scss"],"names":[],"mappings":"AAYA,4BAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAXF;;AAcA,iBAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAXF;AAaE;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AA1BJ;AAUI;EACE,2CAAA;EACA,mBAAA;AARN;AAYI;EACE,2CAAA;EACA,mBAAA;AAVN;AAcI;EACE,qCAAA;AAZN;AAgBI;EACE,sBAAA;AAdN;AAiBI;EACE,WAAA;EACA,YAAA;AAfN;;AAoBA,iBAAA;AACA;EACE,uBAAA;EACA,4BAAA;EACA,gBAAA;AAjBF;AAmBE;EACE,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;AAjBJ;AAoBE;EACE,qCAAA;EACA,4BAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAlBJ;;AAsBA,gBAAA;AACA;EACE,WAAA;AAnBF;;AAsBA,eAAA;AACA;EACE,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,wDAAA;EAEA,iBAAA;EAMA,gBAAA;EAOA,sBAAA;EAQA,eAAA;EAKA,iBAAA;EAmCA,4BAAA;AA5EF;AAgBE;EACE,sCAAA;EACA,8CAAA;AAdJ;AAkBE;EACE,uCAAA;EACA,mBAAA;EACA,eAAA;AAhBJ;AAoBE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAlBJ;AAsBE;EACE,uBAAA;AApBJ;AAwBE;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AArCJ;AAqBI;EACE,2CAAA;EACA,mBAAA;AAnBN;AAuBI;EACE,2CAAA;EACA,mBAAA;AArBN;AAyBI;EACE,qCAAA;AAvBN;AA2BI;EACE,sBAAA;AAzBN;AA+BI;EACE,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EAQA,iBAAA;EAOA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;EAKA,mBAAA;AAvDN;AA0BM;EACE,oCAAA;EACA,sCAAA;EACA,YAAA;EACA,yBAAA;AAxBR;AA2BM;EACE,iDAAA;EACA,mBAAA;EACA,8CAAA;AAzBR;AA6BM;EACE,iDAAA;EACA,mBAAA;AA3BR;AA+BM;EACE,gDAAA;AA7BR;AAiCM;EACE,+CAAA;AA/BR;AAmCM;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAjCR;;AAuCA,qBAAA;AACA;EACE,qBAAA;EACA,uCAAA;AApCF;;AAuCA,uBAAA;AACA;EACE,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;AApCF;;AAuCA,2BAAA;AACA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8DAAA;EAEA,iBAAA;EAOA,0BAAA;EAMA,gBAAA;EAMA,iBAAA;AArDF;AAmCE;EACE,2CAAA;EACA,mBAAA;EACA,sCAAA;AAjCJ;AAqCE;EACE,2CAAA;EACA,mBAAA;AAnCJ;AAuCE;EACE,yBAAA;EACA,sCAAA;AArCJ;AAyCE;EACE,yBAAA;AAvCJ;AA0CE;EACE,kBAAA;EACA,yCAAA;EACA,cAAA;AAxCJ;AA2CE;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,wCAAA;EACA,SAAA;AAzCJ;AA4CE;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;EACA,gBAAA;AA1CJ;;AA8CA,4BAAA;AACA;EACE,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,8BAAA;EACA,oCAAA;EACA,wDAAA;AA3CF;AA6CE;EACE,2BAAA;EACA,oCAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,iCAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;EAEA,iBAAA;EAOA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AA3DJ;AA0CI;EACE,2CAAA;EACA,oBAAA;EACA,yCAAA;AAxCN;AA4CI;EACE,2CAAA;EACA,oBAAA;AA1CN;AA8CI;EACE,0CAAA;AA5CN;AAgDI;EACE,0CAAA;AA9CN;AAiDI;EACE,mBAAA;AA/CN;AAkDI;EACE,oCAAA;EACA,iBAAA;AAhDN;AAmDI;EACE,kBAAA;AAjDN;;AAsDA,mBAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAnDF;;AAsDA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AAnDF;;AAsDA,oBAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,sCAAA;EAEA,iBAAA;EAOA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AAnEF;AAkDE;EACE,iDAAA;EACA,mBAAA;EACA,8CAAA;AAhDJ;AAoDE;EACE,iDAAA;EACA,mBAAA;AAlDJ;AAsDE;EACE,gDAAA;AApDJ;AAwDE;EACE,+CAAA;AAtDJ;AAzWE;EA2XF;IAwCI,YAAA;EAtDF;AACF;;AAyDA,uBAAA;AACA;EACE,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,sCAAA;EAEA,iBAAA;EAOA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AAtEF;AAqDE;EACE,0BAAA;EACA,mBAAA;EACA,8CAAA;AAnDJ;AAuDE;EACE,0BAAA;EACA,mBAAA;AArDJ;AAyDE;EACE,yBAAA;AAvDJ;AA2DE;EACE,yBAAA;AAzDJ;AA4DE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA1DJ;AA1ZE;EAwaF;IAgDI,YAAA;IACA,YAAA;EA1DF;AACF;;AA6DA,eAAA;AACA;EACE,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA1DF;AA4DE;EACE,cAAA;AA1DJ;AAtaE;EA+dA;IAGI,aAAA;EAxDJ;AACF;AA2DE;EACE,aAAA;AAzDJ;AA9aE;EAseA;IAGI,cAAA;EAvDJ;AACF;;AA2DA;EACE,eAAA;EACA,iBAAA;EACA,SAAA;AAxDF;;AA2DA,WAAA;AACA;EACE,oCAAA;EACA,yBAAA;EACA,YAAA;AAxDF;;AA2DA;;EAEE,iBAAA;EACA,+BAAA;EACA,gBAAA;AAxDF;AA7cE;EAigBF;;IAOI,6BAAA;IACA,oCAAA;EAtDF;AACF;AAwDE;;EACE,OAAA;EACA,+CAAA;EACA,uBAAA;EACA,kBAAA;AArDJ;AAuDI;;EACE,iBAAA;AApDN;AAuDI;;EACE,gBAAA;AApDN;AAuDI;;EACE,uBAAA;EACA,iCAAA;EACA,4BAAA;AApDN;AAsDM;;EACE,uBAAA;EACA,iCAAA;AAnDR;;AAyDA,uBAAA;AACA;EACE,aAAA;EAKA,iBAAA;AA1DF;AApfE;EAwiBF;IAGI,cAAA;EAnDF;AACF;AAuDE;EACE,iBAAA;EACA,2BAAA;EACA,+CAAA;EACA,mBAAA;AArDJ;;AAyDA;EACE,aAAA;AAtDF;AA7fE;EAkjBF;IAGI,cAAA;EApDF;AACF;;AAuDA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AApDF;AAsDE;EACE,WAAA;AApDJ;AA3gBE;EAyjBF;IAUI,aAAA;EApDF;AACF;;AAthBE;EA6kBF;IAEI,kBAAA;IACA,iBAAA;EApDF;AACF;;AAuDA,oCAAA;AAEE;EACE,mBAAA;AArDJ;AAuDI;EACE,qBAAA;EACA,6CAAA;AArDN;AA0DI;EACE,0BAAA;AAxDN;AA4DE;EACE,4BAAA;EACA,uBAAA;AA1DJ;AA4DI;EACE,6BAAA;AA1DN;AA8DE;EACE,mBAAA;EACA,iBAAA;AA5DJ;AA8DI;EACE,0BAAA;AA5DN;AA+DI;EACE,uBAAA;AA7DN;AAiEE;EACE,8BAAA;AA/DJ;AAiEI;EACE,uBAAA;AA/DN;AAiEM;EACE,0BAAA;EACA,yBAAA;AA/DR;AAoEE;EACE,iBAAA;EACA,uBAAA;AAlEJ;AAoEI;EACE,6BAAA;AAlEN;AAsEE;EACE,uBAAA;EACA,uBAAA;AApEJ","sourcesContent":["@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n/* Accessibility utilities */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Close button */\n.cross_icon {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  \n  .close-button {\n    background: transparent;\n    border: none;\n    padding: 8px;\n    cursor: pointer;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n    /* Focus styles */\n    &:focus {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Keyboard focus styles */\n    &:focus-visible {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Hover state */\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n    \n    /* Active state */\n    &:active {\n      transform: scale(0.95);\n    }\n    \n    ion-img {\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n/* Hero section */\n.hero {\n  padding: 30px 25px 25px;\n  color: var(--ion-color-main);\n  text-align: left;\n  \n  h1 {\n    font-family: AppFontSemiBold, sans-serif;\n    font-size: 22px;\n    line-height: 33px;\n    text-transform: uppercase;\n    margin: 10px 0px 5px;\n  }\n  \n  p {\n    font-family: AppFontLight, sans-serif;\n    color: rgba(47, 51, 58, 0.7);\n    font-size: 14px;\n    margin-top: 5px;\n    margin-bottom: 15px;\n  }\n}\n\n/* Search form */\n.search-form {\n  width: 100%;\n}\n\n/* Search bar */\n.search-bar {\n  border: 2px solid #e5e5e5;\n  border-radius: 7px;\n  --inner-padding-end: 5px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  \n  /* Focus styles */\n  &:focus-within {\n    border-color: var(--ion-color-primary);\n    box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n  }\n  \n  /* Input field */\n  ion-input {\n    color: var(--ion-color-main) !important;\n    background: #FFFFFF;\n    font-size: 16px;\n  }\n  \n  /* Container styling */\n  > div {\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    place-items: center;\n  }\n  \n  /* Start icon */\n  .start-icon {\n    margin-inline-end: 12px;\n  }\n  \n  /* Clear button */\n  .clear-button {\n    background: transparent;\n    border: none;\n    padding: 8px;\n    cursor: pointer;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 5px;\n    \n    /* Focus styles */\n    &:focus {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Keyboard focus styles */\n    &:focus-visible {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Hover state */\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n    \n    /* Active state */\n    &:active {\n      transform: scale(0.95);\n    }\n  }\n  \n  /* Search button container */\n  .suche {\n    .search-button {\n      background: var(--ion-color-primary);\n      border: none;\n      border-radius: 6px;\n      color: white;\n      fill: white;\n      min-height: 39px;\n      padding: 8px 15px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      gap: 5px;\n\n      span {\n        font-family: AppFontBold, sans-serif;\n        transition: background-color 0.2s ease;\n        color: white;\n        text-transform: uppercase;\n      }\n      /* Focus styles */\n      &:focus {\n        outline: 2px solid var(--ion-color-primary-shade);\n        outline-offset: 2px;\n        box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n      }\n      \n      /* Keyboard focus styles */\n      &:focus-visible {\n        outline: 2px solid var(--ion-color-primary-shade);\n        outline-offset: 2px;\n      }\n      \n      /* Hover state */\n      &:hover:not(:disabled) {\n        background-color: var(--ion-color-primary-shade);\n      }\n      \n      /* Active state */\n      &:active:not(:disabled) {\n        background-color: var(--ion-color-primary-tint);\n      }\n      \n      /* Disabled state */\n      &:disabled {\n        background-color: #cccccc;\n        cursor: not-allowed;\n        opacity: 0.7;\n      }\n    }\n  }\n}\n\n/* Search container */\n.search-container ion-col {\n  padding: 0 !important;\n  border-radius: var(--ion-border-radius);\n}\n\n/* No results message */\n.no-place {\n  padding: 16px 9px;\n  font-family: AppFont-bold, sans-serif;\n  background: #FFFFFF;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  border-radius: var(--ion-border-radius);\n  font-size: 12px;\n  line-height: 131.5%;\n  color: var(--ion-color-secondary);\n}\n\n/* Suggested place button */\n.suggested-place {\n  border-radius: 7px;\n  border: 2px solid #D5DDDD;\n  background: #F7F9F9;\n  place-items: center;\n  padding: 15px 20px;\n  margin-top: 5px;\n  text-align: left;\n  width: 100%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n  \n  /* Focus styles */\n  &:focus {\n    outline: 2px solid var(--ion-color-primary);\n    outline-offset: 2px;\n    border-color: var(--ion-color-primary);\n  }\n  \n  /* Keyboard focus styles */\n  &:focus-visible {\n    outline: 2px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n  \n  /* Hover state */\n  &:hover {\n    background-color: #E8F0F0;\n    border-color: var(--ion-color-primary);\n  }\n  \n  /* Active state */\n  &:active {\n    background-color: #D0E4E4;\n  }\n  \n  .navigate-icon {\n    margin-right: 15px;\n    fill: var(--ion-color-primary) !important;\n    flex-shrink: 0;\n  }\n\n  .actual-position-title {\n    font-size: 14px;\n    line-height: 17px;\n    text-transform: uppercase;\n    color: var(--ion-color-primary);\n    font-family: AppFontSemiBold, sans-serif;\n    margin: 0;\n  }\n\n  .actual-position {\n    font-size: 13px;\n    margin-top: 5px;\n    line-height: 16px;\n    color: #6D7075;\n    font-family: AppFontLight, sans-serif;\n    margin-bottom: 0;\n  }\n}\n\n/* Search results dropdown */\n.pac-container {\n  background: white;\n  width: 100%;\n  padding: 8px 0 !important;\n  margin-top: 5px;\n  border-radius: 16px !important;\n  border: 2px solid #e5e5e5 !important;\n  box-shadow: 0px 0px 42px 0px #00000012;\n  \n  .pac-item {\n    border-top: none !important;\n    font-family: AppFontBold, sans-serif;\n    padding: 16px 20px;\n    line-height: 1 !important;\n    font-size: 14px !important;\n    color: var(--ion-color-secondary);\n    background: transparent;\n    border: none;\n    width: 100%;\n    text-align: left;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    \n    /* Focus styles */\n    &:focus {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: -2px;\n      background-color: rgba(113, 167, 97, 0.1);\n    }\n    \n    /* Keyboard focus styles */\n    &:focus-visible {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: -2px;\n    }\n    \n    /* Hover state */\n    &:hover {\n      background-color: rgba(113, 167, 97, 0.05);\n    }\n    \n    /* Active state */\n    &:active {\n      background-color: rgba(113, 167, 97, 0.15);\n    }\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    .pac-matched {\n      font-family: AppFontBold, sans-serif;\n      font-weight: bold;\n    }\n    \n    .pac-icon {\n      margin-right: 10px;\n    }\n  }\n}\n\n/* Footer buttons */\n#buttonContainer {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n\n.vertical-space-around {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n}\n\n/* Continue button */\n.cnt-btn {\n  width: 100%;\n  padding: 16px;\n  text-align: center;\n  font-family: AppFontBold, sans-serif;\n  color: white;\n  font-weight: bold;\n  letter-spacing: 0.075em;\n  text-transform: uppercase;\n  cursor: pointer;\n  margin: 0;\n  background: var(--ion-color-primary);\n  border-radius: 50px;\n  border: none;\n  transition: background-color 0.2s ease;\n  \n  /* Focus styles */\n  &:focus {\n    outline: 2px solid var(--ion-color-primary-shade);\n    outline-offset: 2px;\n    box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n  }\n  \n  /* Keyboard focus styles */\n  &:focus-visible {\n    outline: 2px solid var(--ion-color-primary-shade);\n    outline-offset: 2px;\n  }\n  \n  /* Hover state */\n  &:hover {\n    background-color: var(--ion-color-primary-shade);\n  }\n  \n  /* Active state */\n  &:active {\n    background-color: var(--ion-color-primary-tint);\n  }\n  \n  @include desktop {\n    margin: auto;\n  }\n}\n\n/* Geolocation button */\n.geo-btn {\n  background: #62ABA4;\n  font-family: AppFont-bold, sans-serif;\n  color: #ffffff;\n  font-weight: bold;\n  cursor: pointer;\n  width: 100%;\n  padding: 16px;\n  text-align: center;\n  letter-spacing: 0.075em;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  border-radius: 50px;\n  transition: background-color 0.2s ease;\n  \n  /* Focus styles */\n  &:focus {\n    outline: 2px solid #4A8A83;\n    outline-offset: 2px;\n    box-shadow: 0 0 0 3px rgba(98, 171, 164, 0.25);\n  }\n  \n  /* Keyboard focus styles */\n  &:focus-visible {\n    outline: 2px solid #4A8A83;\n    outline-offset: 2px;\n  }\n  \n  /* Hover state */\n  &:hover {\n    background-color: #4A8A83;\n  }\n  \n  /* Active state */\n  &:active {\n    background-color: #3F7A73;\n  }\n\n  ion-icon {\n    width: 22px;\n    height: 25px;\n    margin-right: 10px;\n  }\n\n  @include desktop {\n    width: 600px;\n    margin: auto;\n  }\n}\n\n/* Typography */\n.heading-text {\n  font-size: 19px;\n  color: var(--ion-text-color);\n  font-weight: 500;\n  line-height: 145%;\n  margin: 20px 0 10px;\n\n  &.desktop {\n    display: block;\n    @include mobile() {\n      display: none;\n    }\n  }\n\n  &.mobile {\n    display: none;\n    @include mobile() {\n      display: block;\n    }\n  }\n}\n\n.sub-heading {\n  font-size: 18px;\n  line-height: 134%;\n  margin: 0;\n}\n\n/* Footer */\n.footer-btn {\n  font-family: AppFontBold, sans-serif;\n  text-transform: uppercase;\n  color: white;\n}\n\nion-footer,\n.footer-btn {\n  background: unset;\n  padding: 0 28px 26px !important;\n  box-shadow: none;\n  \n  @include desktop {\n    margin: 0px 50px 0 !important;\n    width: calc(100% - 100px) !important;\n  }\n\n  .button {\n    flex: 1;\n    background: var(--ion-color-primary) !important;\n    color: white !important;\n    text-align: center;\n\n    &:first-child {\n      margin-right: 3px;\n    }\n\n    &:last-child {\n      margin-left: 3px;\n    }\n\n    &.active {\n      transition: 0.3s linear;\n      background: var(--ion-color-main);\n      color: var(--ion-text-color);\n\n      &:hover {\n        transition: 0.3s linear;\n        background: var(--ion-color-main)\n      }\n    }\n  }\n}\n\n/* Responsive layouts */\n.desktop {\n  display: none;\n  @include desktop() {\n    display: block;\n  }\n\n  margin: 50px 25px;\n  \n  .hero {\n    background: white;\n    border: 0.5px solid #E5E5E5;\n    box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);\n    border-radius: 10px;\n  }\n}\n\n.mobile {\n  display: none;\n  @include mobile() {\n    display: block;\n  }\n}\n\n.logo-block {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  \n  ion-img {\n    width: 76px;\n  }\n  \n  @include mobile {\n    display: none;\n  }\n}\n\n.desktop-hero {\n  @include desktop() {\n    text-align: center;\n    margin: 50px 25px;\n  }\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n  .search-bar {\n    border-color: black;\n    \n    &:focus-within {\n      border-color: #0078d7;\n      box-shadow: 0 0 0 3px rgba(0, 120, 215, 0.25);\n    }\n  }\n  \n  .close-button, .clear-button {\n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n  }\n  \n  .search-button {\n    background: black !important;\n    border: 2px solid white;\n    \n    &:focus {\n      box-shadow: 0 0 0 3px #0078d7;\n    }\n  }\n  \n  .suggested-place {\n    border-color: black;\n    background: white;\n    \n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n    \n    .actual-position-title, .actual-position {\n      color: black !important;\n    }\n  }\n  \n  .pac-container {\n    border-color: black !important;\n    \n    .pac-item {\n      color: black !important;\n      \n      &:focus {\n        outline: 3px solid #0078d7;\n        background-color: #e6f3ff;\n      }\n    }\n  }\n  \n  .cnt-btn {\n    background: black;\n    border: 2px solid white;\n    \n    &:focus {\n      box-shadow: 0 0 0 3px #0078d7;\n    }\n  }\n  \n  .no-place {\n    border: 2px solid black;\n    color: black !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
